// removed by extract-text-webpack-plugin
module.exports = {"chartComponent":"dam-info-module__chartComponent___o17ws","title":"dam-info-module__title___3ar8n","chart":"dam-info-module__chart___KnSBK","smallDescription":"dam-info-module__smallDescription___26YXB","tableComponent":"dam-info-module__tableComponent___3VIkT","table":"dam-info-module__table___1QIIx","tableHeading":"dam-info-module__tableHeading___3mFR9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/dam-info/dam-info.module.scss
// module id = 648
// module chunks = 0 1